import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BulkUploadStatusSectionComponent from './BulkUploadStatusSectionComponent';
import { getModel } from './selectors';
import * as actions from './actions';


const BulkUploadStatusSectionContainer = (props) => {
	return <BulkUploadStatusSectionComponent {...props}/>;
};

const mapStateToProps = (state) => {
	const model = getModel(state);
	return { model };
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
};

const BulkUploadStatusSectionContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(BulkUploadStatusSectionContainer);

export default BulkUploadStatusSectionContainerConn;
